import { Injectable } from "@angular/core";
import { BehaviorSubject, of, Observable } from "rxjs";
import { City, CityProps } from "../models/City.model";
import { delay, map } from "rxjs/operators";
import { CityContact, CityContactProps } from "../models/CityContact.model";
import { HttpService } from "src/app/shared/http.service";
import { APIEndpoints } from "src/config/apiEndpoint.config";

@Injectable()
export class CityListService {
  private $cities: BehaviorSubject<City[]> = new BehaviorSubject<City[]>([]);
  get citiesObservable(): Observable<City[]> {
    return this.$cities;
  }

  private $selectedCity: BehaviorSubject<City> = new BehaviorSubject<City>(
    undefined
  );
  get selectedCityObservable(): Observable<City> {
    return this.$selectedCity;
  }

  set selectedCity(value: City) {
    this.$selectedCity.next(value);
  }

  get selectedCity() {
    return this.$selectedCity.value;
  }

  constructor(private readonly httpService: HttpService) {}

  async refresh(searchText?: string) {
    const cities = await this.httpService
      .get<CityProps[]>(APIEndpoints.getCityContacts)
      .pipe(map((x) => City.createMany(x)))
      .toPromise();
    let filtered = cities;
    if (searchText)
      filtered = filtered.filter((x) => x.name.includes(searchText));

    this.$cities.next(filtered);

    if (this.selectedCity) {
      const city = filtered.find((x) => x.name === this.selectedCity.name);
      this.$selectedCity.next(city);
    }
  }

  async update(cityContact: CityContactProps) {
    const { name } = this.selectedCity;
    await this.httpService
      .post(APIEndpoints.upsertCityContact, { name, cityContact })
      .toPromise();
    const city = this.$cities.value.find((x) => x.name === name);
    city.contact = CityContact.create(cityContact);
    const filteredCities = this.$cities.value;
    const filteredCity = filteredCities.find((x) => x.name === name);
    filteredCity.contact = CityContact.create(cityContact);
    this.$cities.next(filteredCities);
  }
}
